import React from 'react';

export function wrapComponent<T>(Component: React.FC<any>, Wrapper: React.FC<any>): T {
	return (((props: any = {}) => (
		<Wrapper>
			<Component {...props} />
		</Wrapper>
	)) as unknown) as T;
}
